import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-image-preview',
  templateUrl: './image-preview.component.html',
  styleUrls: ['./image-preview.component.scss']
})
export class ImagePreviewComponent {
  private readonly minZoom = 0.5;
  private readonly maxZoom = 3;
  private readonly zoomStep = 0.25;

  @Input() visible = false;
  @Input() title = 'Image Preview';
  @Input() imageUrl: SafeUrl | null = null;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() closed = new EventEmitter<void>();

  public zoomLevel = 1;

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes['visible'] && changes['visible'].currentValue) || changes['imageUrl']) {
      this.resetZoom();
    }
  }

  close(): void {
    this.resetZoom();
    this.visible = false;
    this.visibleChange.emit(false);
    this.closed.emit();
  }

  zoomIn(): void {
    this.zoomLevel = Math.min(this.maxZoom, this.zoomLevel + this.zoomStep);
  }

  zoomOut(): void {
    this.zoomLevel = Math.max(this.minZoom, this.zoomLevel - this.zoomStep);
  }

  resetZoom(): void {
    this.zoomLevel = 1;
  }

  downloadImage(): void {
    if (!this.imageUrl) {
      return;
    }

    const anchor = document.createElement('a');
    anchor.href = String(this.imageUrl);
    anchor.download = this.title || 'image';
    anchor.target = '_blank';
    anchor.rel = 'noopener';
    anchor.click();
  }
}
